import React, { useState, useEffect } from "react";
import { Row, Col, InputNumber, Checkbox, Button, Select } from "antd";
import CustomModal from "../modals/customModal";
import "./index.css";
// import RmxCover from "../../assets/images/distributors-banner.jpg";
import Configuration from "../../assets/images/configuration.png";
import EstimatedShippingCost from "../../assets/images/description.png";
import { numberWithCommas } from "../../config/utils";

import { IoCloseCircle } from "react-icons/all";
import info from "../info";
let checkedValues = 0;

export default function AddProduct({
  inputText,
  inputTitle,
  backgroundImage,
  productData,
  onCheckout,
  isshowAddProduct,
  updateCartState,
}) {
  let [NewCatalogInput, setNewCatalogInput] = useState(true);
  let [isOpenModal, setIsOpenModal] = useState(false);
  let [quantity, setQuantity] = useState(1);
  let [selectedAditivePrice, setSelectedAditivePrice] = useState();
  let [cardCount, setCartCount] = useState(0);
  let [productDetail, setProductDetail] = useState(productData);
  let [selectedCurrencyIndex, setSelectedCurrencyIndex] = useState(0);
  let [productTotalPrice, setProductTotalPrice] = useState(quantity * productData?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.price || productData?.price);
  let [totalPrice, setTotalPrice] = useState(quantity * productData?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.price || productData?.price);
  let [newProductPrice, setNewProductPrice] = useState(productData?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.price || productData?.price);
  const [quantityError, setQuantityError] = useState("");
  const [currency, setCurrency] = useState('');
  useEffect(() => {
    checkedValues = 0;
  }, []);

  useEffect(() => {
    setTotalPrice(checkedValues * quantity + quantity * productData?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.price || productData?.price);
    setProductTotalPrice(quantity * productData?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.price || productData?.price);
    setNewProductPrice(productData?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.price || productData?.price);
    setCurrency(productData?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency)
  }, [selectedCurrencyIndex]);

  // WORKING======
  const onChangeQuantity = (e, productDetail) => {
    console.log("quantityStatus==>", e, productDetail);
    if (e === 0 || e < 0 || e == null) {
      setQuantityError("Quantity must be greater than 0");
      setQuantity(e);
      return;
    } else {
      setQuantityError("");
    }
    // a check to see if product prices array length == 0 means an old product.
    let pp;
    if (!newProductPrice) {
      let productPrice = productDetail?.rmx_product_prices?.length == 0;
      // if an old product
      if (productPrice) {
        pp = e * productDetail?.price;
      }
      // a new product that can have multiple currencies scenerios
      else {
        const product = productDetail?.rmx_product_prices?.find(
          (productPrice) => productPrice?.rmx_product_price?.currency === String(currency));
        if (product) {
          pp = e * Number(product?.rmx_product_price?.price)
        }
      }
    }
    else {
      pp = newProductPrice * e;
    }
    setQuantity(e);
    setCartCount(e);
    setTotalPrice(pp + checkedValues * e);
    setProductTotalPrice(pp);
  };

  const onChangeProductPrice = (price) => {
    setNewProductPrice(price);
    let pp = quantity * price;
    setCartCount(quantity);
    setTotalPrice(pp + checkedValues * quantity);
    setProductTotalPrice(pp);
  };
  const selectPrice = (index, checked) => {
    console.log("selectPrice==>", index, checked);
    let PD = { ...productDetail };
    PD.rmx_product_additives[index]["selected"] = checked;
    setProductDetail(PD);
  };
  let checkoutData = [];
  if (localStorage.getItem("cart")) {
    checkoutData = [...JSON.parse(localStorage.getItem("cart") || {})];
  }
  console.log("ProductPrice===>", productDetail);
  return (
    <Row justify="start" style={{ marginTop: "40px" }}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="custom">
        <Row justify="center" style={{ marginBottom: "20px" }} gutter={[0, 0]}>
          <Col
            xl={6}
            xs={6}
            sm={6}
            md={6}
            lg={5}
            className="rmx-productimage"
            style={{
              backgroundImage: `url(${productDetail?.image?.original})`,
            }}
          ></Col>
          <Col
            xl={10}
            xs={8}
            sm={8}
            md={8}
            lg={11}
            style={{ paddingLeft: "10px" }}
          >
            <Row justify="start">
              <Col xl={24} xs={24} sm={24} md={24} lg={14}>
                <h2
                  className="text-left"
                  style={{
                    fontSize: "30px",
                    lineHeight: "115%",
                    fontWeight: 300,
                    color: "#444",
                  }}
                >
                  {productDetail?.name}
                  <br></br>
                  <small
                    style={{ color: "#09c1b2 ", fontSize: "80%" }}
                    className="text-left"
                  >
                    {
                      productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.price
                        ? `${productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency}
                          ${Number(productDetail?.rmx_product_prices[selectedCurrencyIndex]?.rmx_product_price?.price).toFixed(2)}/${productDetail?.unit
                        }`
                        :
                        !productDetail?.price
                          ? `$ ${(0.0).toFixed(2)} /${productDetail?.unit} `
                          : `$${Number(productDetail?.price).toFixed(2)}/${productDetail?.unit
                          }`}
                  </small>
                </h2>
              </Col>
            </Row>

            <Row style={{ marginBottom: "10px" }}>
              <Col xl={24} xs={24} sm={24} md={24} lg={14}>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "start",
                    textAlign: "justify",
                  }}
                >
                  Product Taxable:{productDetail?.basemix?.name}
                </span>
              </Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              {productDetail?.description && (
                <Col xl={24} xs={24} sm={24} md={24} lg={14}>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "start",
                      textAlign: "justify",
                    }}
                  >
                    {productDetail?.description}
                  </span>
                </Col>
              )}
            </Row>
          </Col>

          <Col xl={6} xs={6} sm={6} md={6} lg={6}>
            <Row justify="start" align="middle">
              <Col xl={12}>
                <label
                  className="text-left"
                  style={{
                    fontSize: "1.0rem",
                    // color: "#9e9e9e",
                    color: "#000",
                    paddingLeft: "15px",
                  }}
                >
                  Quantity
                </label>
              </Col>
              <Col xl={8}>
                <InputNumber
                  onChange={(e) => onChangeQuantity(e, productDetail)}
                  value={quantity}
                  defaultValue={quantity}
                  type="number"
                />
              </Col>
              <Col span={24}>
                <p
                  className="danger-color"
                  style={{ fontSize: "0.75rem", marginTop: "10px" }}
                >
                  {quantityError}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: "2.5rem" }}>
          <Col
            span={22}
            style={{
              border: "1px solid #F0F0F0",
              padding: "1.5rem",
              minHeight: "189px",
              marginBottom: "20px",
            }}
          >
            <Row justify="start">
              <Col span={12} style={{ position: "relative" }}>
                <img
                  src={Configuration}
                  style={{
                    position: "absolute",
                    backgroundRepeat: "no-repeat",
                    top: "-50px",
                    display: "flex",
                  }}
                />
              </Col>
              <Col xl={24} lg={24} md={24} xs={24} sm={24}>
                <Row
                  justify="space-between"
                  style={{ marginBottom: "25px" }}
                  align="middle"
                >
                  <Col xl={12} lg={12} md={16} xs={24} sm={24}>
                    <h2
                      className="text-left rmx-left"
                      style={{ fontSize: "1.4rem" }}
                    >
                      {productDetail?.name}
                    </h2>
                  </Col>
                  <Col
                    xl={12}
                    lg={12}
                    md={8}
                    xs={24}
                    sm={24}
                    className="rmx-right"
                  >
                    <Row align="middle" justify="end">
                      <Col
                        xl={24}
                        lg={6}
                        md={6}
                        xs={6}
                        sm={6}
                        style={{ color: "black" }}
                      >
                        <span
                          className="rmx-right"
                          style={{
                            color: "black",
                            fontSize: "1.4rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {
                            <Select
                              defaultValue={productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency || "$"}
                              onChange={(value) => {
                                const index = productDetail?.rmx_product_prices?.findIndex(
                                  (item) => item?.rmx_product_price?.currency === value
                                );
                                console.log("selectedCurrencyIndex", value);

                                setSelectedCurrencyIndex(index);
                                setCurrency(value)
                              }}
                              options={productDetail?.rmx_product_prices?.map((item) => ({
                                label: item?.rmx_product_price?.currency,
                                value: item?.rmx_product_price?.currency,
                              }))}
                            />
                            // productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency
                            //   ? productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency
                            //   : "$"
                          }
                          <span style={{ padding: "8px", fontSize: "1.4rem", marginRight: '10px' }}>
                            <InputNumber
                              onChange={(e) => {
                                onChangeProductPrice(e);
                              }}
                              value={newProductPrice}
                              type="number"
                              style={{ whiteSpace: "nowrap" }}
                              min={0}
                            />
                            {/* {!productDetail?.price ? `${(0.0).toFixed(2)} ` : Number(productDetail?.price).toFixed(2)} */}
                          </span>
                          <span style={{ padding: "8px", fontSize: "1rem" }}>
                            <InputNumber
                              onChange={(e) =>
                                onChangeQuantity(e, productDetail)
                              }
                              value={quantity}
                              defaultValue={quantity}
                              type="number"
                              style={{ whiteSpace: "nowrap" }}
                            />
                          </span>
                          <span style={{ paddingLeft: "8px" }}>
                            {`${productDetail?.unit} = 
                            ${productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency ? productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency : "$"}
                            ${numberWithCommas(
                              Number(productTotalPrice).toFixed(2)
                              // Number(totalPrice).toFixed(2)
                            )}`}
                          </span>
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Row justify="start">
                    <Col span={24}>
                      <p
                        className="danger-color"
                        style={{ fontSize: "0.75rem", marginTop: "10px" }}
                      >
                        {quantityError}
                      </p>
                    </Col>
                  </Row>
                </Row>
                {(productDetail?.rmx_product_additives || []).map(
                  (item, index) => {
                    return (
                      <Row
                        justify="start"
                        gutter={[60, 40]}
                        style={{ paddingBottom: "25px" }}
                      >
                        <Col span={12} className="text-left">
                          <Checkbox
                            className="custom-checkbox"
                            value={item.price}
                            onChange={(e) => {
                              checkedValues = e.target.checked
                                ? Number(checkedValues) + Number(e.target.value)
                                : Number(checkedValues) -
                                Number(e.target.value);
                              const pp = newProductPrice * quantity;
                              if (!newProductPrice) {
                                setTotalPrice((0.0).toFixed(2));
                              } else {
                                setTotalPrice(pp + checkedValues * quantity);
                              }

                              selectPrice(
                                index,
                                e.target.checked ? true : false
                              );
                              setSelectedAditivePrice(checkedValues);
                            }}
                          >
                            {console.log(
                              "checkedValue===>",
                              selectedAditivePrice
                            )}
                            <span
                              className="cursor-pointer"
                              style={{ fontSize: "1rem", color: "#000" }}
                            >
                              {item?.name}
                            </span>
                          </Checkbox>
                        </Col>
                        <Col
                          span={12}
                          className="text-right"
                          style={{ color: "#09c1b2" }}
                        >
                          <span
                            style={{
                              fontSize: "1rem",
                              color: "#09c1b2",
                              fontWeight: "300",
                            }}
                          >
                            {`${numberWithCommas(
                              Number(item.price).toFixed(2)
                            )}`}
                          </span>
                        </Col>
                      </Row>
                    );
                  }
                )}
              </Col>
            </Row>
          </Col>
          <Col span={22} style={{ marginTop: "-6.8px" }}>
            <Row justify="end">
              <Col>
                <span className="prod-total">
                  <span>Total = </span>
                  <span
                    className="product-total-color"
                    style={{ fontWeight: "600" }}
                  >
                    {`${productDetail?.rmx_product_prices.length > 0 && productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency || "$"}
                      ${numberWithCommas(Number(totalPrice).toFixed(2))}`}
                  </span>
                </span>
              </Col>
            </Row>
          </Col>
          <Col span={22} style={{ marginTop: "40px", marginBottom: "30px" }}>
            <Row justify="end">
              <Col span={5}>
                <Button
                  style={{
                    backgroundColor: "#ff9800 ",
                    color: "#fff",
                    border: "none",
                    width: "100%",
                  }}
                  onClick={() => {

                    if (!quantity) return;
                    // if (checkoutData.length) {
                    //   if (!quantityError || !totalPrice) {
                    //     setIsOpenModal(true);
                    //     checkoutData.push({
                    //       ...productDetail,
                    //       quantity,
                    //       price: Number(totalPrice),
                    //       actualProdcutPrice: Number(productDetail?.price),
                    //       selectedAditivePrice: Number(selectedAditivePrice),
                    //       user_id: JSON.parse(localStorage?.getItem("trkr_contractor_auth"))[0]?.user?.id
                    //     });
                    //     localStorage?.setItem(
                    //       "cart",
                    //       JSON.stringify(checkoutData)
                    //     );
                    //   }
                    // }
                    // else {
                    const selectedCurrency = productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency;

                    console.log("checkoutData before", checkoutData);
                    if (!quantityError || !totalPrice) {
                      (checkoutData || []).find((el, prdouctindex) => {
                        if (el?.id == productDetail?.id) {
                          checkoutData.splice(prdouctindex, 1);
                          localStorage.setItem(
                            "cart",
                            JSON.stringify(checkoutData)
                          );
                        }
                      });
                      setIsOpenModal(true);
                      checkoutData.push({
                        ...productDetail,
                        quantity,
                        selectedCurrency: productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency || "$",
                        // price: Number(newProductPrice || productDetail?.price || 0),
                        price: Number(productDetail?.price || 0),
                        actualProdcutPrice: Number(newProductPrice || 0),
                        selectedCurrency: productDetail?.rmx_product_prices?.[selectedCurrencyIndex]?.rmx_product_price?.currency || "$",
                        rmx_product_prices: productDetail?.rmx_product_prices?.map((item) => {
                          if (item?.rmx_product_price?.currency === selectedCurrency) {
                            return {
                              ...item,
                              rmx_product_price: {
                                ...item.rmx_product_price,
                                price: Number(newProductPrice),
                              },
                            };
                          }
                          return item; // leave others as-is
                        }),
                        selectedAditivePrice: Number(selectedAditivePrice || 0),
                        user_id: JSON.parse(
                          localStorage?.getItem("trkr_contractor_auth")
                        )[0]?.user?.id,
                      });
                      localStorage?.setItem(
                        "cart",
                        JSON.stringify(checkoutData)
                      );
                      console.log("checkoutData", checkoutData);
                      updateCartState(checkoutData);
                    }

                    // console.log('findProductId', findProductId)
                    // findProductId?.splice(prdouctindex, 1)
                    // if (!quantityError || !totalPrice) {
                    //   setIsOpenModal(true);
                    //   checkoutData.push({
                    //     ...productDetail,
                    //     quantity,
                    //     price: Number(totalPrice),
                    //     actualProdcutPrice: Number(productDetail?.price),
                    //     selectedAditivePrice: Number(selectedAditivePrice),
                    //     user_id: JSON.parse(localStorage?.getItem("trkr_contractor_auth"))[0]?.user?.id
                    //   });
                    //   localStorage?.setItem(
                    //     "cart",
                    //     JSON.stringify(checkoutData)
                    //   );
                    // }

                    // }
                  }}
                >
                  ADD TO CART
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        {productDetail?.description && (
          <Row justify="center">
            <Col
              span={22}
              style={{
                border: "1px solid #F0F0F0",
                padding: "1rem",
                minHeight: "189px",
                marginBottom: "20px",
              }}
            >
              <Row justify="start">
                <Col span={12} style={{ position: "relative" }}>
                  <img
                    src={EstimatedShippingCost}
                    style={{
                      position: "absolute",
                      backgroundRepeat: "no-repeat",
                      top: "-32px",
                      display: "flex",
                    }}
                  />
                </Col>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  xs={24}
                  sm={24}
                  style={{ marginTop: "1.5rem" }}
                >
                  <span
                    className="text-left"
                    style={{ display: "flex", justifyContent: "start" }}
                  >
                    {productDetail?.description}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        )}

        <CustomModal
          visible={isOpenModal}
          onCancelModal={() => setIsOpenModal(false)}
          closeIcon={<IoCloseCircle size={25} />}
          footer={[
            <Row justify="center" style={{ margin: "20px" }} gutter={[30, 0]}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
                span={24}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => {
                    onCheckout(
                      { ...productDetail, price: newProductPrice },
                      quantity,
                      totalPrice
                    );
                  }}
                >
                  CHECKOUT
                </Button>
                <Button
                  style={{
                    backgroundColor: "#9e9e9e",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  // onClick={() => setIsOpenModal(false)}
                  onClick={() => {
                    isshowAddProduct(
                      { ...productDetail, price: newProductPrice },
                      quantity,
                      totalPrice
                    );
                  }}
                >
                  CONTINUE
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            {/* <Col className="d-flex justify-content-center" span={24}>
              <img src={Delete_order} />
            </Col> */}
            <Col
              span={18}
              style={{ textAlign: "center" }}
              className="modal-heading"
            >
              <h5 className="modal-title">
                The Product has been added to your Cart
              </h5>
            </Col>
          </Row>
        </CustomModal>
      </Col>
    </Row>
  );
}
